import { Image, Box } from "@chakra-ui/react";

export function ChakraImage(props) {
    return (
        <Box maxW="sm" overflow="hidden" p={4}>
            <Image
                src={props.picturePath}
                alt={props.name}
                borderRadius="full"
                boxSize="100%"
                maxW="220px"
                aspectRatio="1 / 1"
                objectFit="cover"
            />
        </Box>
    );
}